/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileZipIcon = ({ width = 24, height = 24, hidden = false, title = 'File Zip' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M20 2v10h10L20 2z" />
    <path
      d="M19 14a1 1 0 0 1-1-1V2h-4v15.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V2H7a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h5v-3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V34h15a1 1 0 0 0 1-1V14Zm-1 13a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V17a1 1 0 0 1 1-1h1v4h6v-4h1a1 1 0 0 1 1 1Z"
    />
    <circle cx="13" cy="24" r="2.186" />
  </svg>`;
};
